import type { Currency, PriceTier } from '@weft/types';
import { Table } from 'antd';
import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import { getUsageProductVariantTableColumns } from '../../../product-variant-plan-table-columns-builder';
import { UsageProductVariantTableEdit } from './UsageProductVariantTableEdit/UsageProductVariantTableEdit';

type UsageProductVariantTableProps = {
  tiers: Partial<PriceTier>[];
  isEditing: boolean;
  productIndex: number;
  productVariantIndex: number;
  currency: Currency
  isVolumeProduct?: boolean;
  isRevShareProduct?: boolean;
  isTieredSubscriptionProduct?: boolean;
  isFlatRate?: boolean;
};

export const UsageProductVariantTable: React.FC<UsageProductVariantTableProps> = ({
  isEditing,
  tiers,
  productIndex,
  productVariantIndex,
  currency,
  isVolumeProduct,
  isRevShareProduct,
  isTieredSubscriptionProduct = false,
  isFlatRate = false,
}) => {
  const columns = useMemo(() => getUsageProductVariantTableColumns(currency, isFlatRate, isTieredSubscriptionProduct), [currency, isFlatRate]);

  return (
    <>
      {isEditing ? (
        <UsageProductVariantTableEdit
          tiers={tiers}
          isFlatRate={isFlatRate}
          productIndex={productIndex}
          productVariantIndex={productVariantIndex}
          isVolumeProduct={isVolumeProduct}
          isRevShareProduct={isRevShareProduct}
          isTieredSubscriptionProduct={isTieredSubscriptionProduct}
        />
      ) : (
        <div className="w-full px-8">
          <Table
            columns={columns}
            dataSource={tiers}
            className="border-t-frame border-t"
            rowClassName="text-center"
            components={{
              header: {
                cell: ({ children }: PropsWithChildren) => (
                  <th
                    className="bg-white text-center text-base before:hidden"
                  >
                    {children}
                  </th>
                ),
              },
            }}
            pagination={{
              hideOnSinglePage: true,
            }}
          />
        </div>
      )}
    </>
  );
};